
export default {
  placesAndDirections: {
    isochrones: 'Isócronos',
    place: 'local',
    notRouteFound: 'Não foi possível encontrar uma rota que conecte os locais usando o perfil selecionado',
    notRouteFoundWithFilters: 'Não foi possível encontrar uma rota que conecte os locais usando o perfil e filtros selecionados',
    noPlaceFound: 'Nenhum local encontrado para o texto inserido',
    routeReady: 'Rota calculada',
    useLocation: 'GPS',
    addPlaceInput: 'Adicionar local',
    clearRoute: 'Remover rota',
    reverseRoute: 'Reverter',
    orderByClosestPlaces: 'Ordear por locais mais próximos',
    calculatingRoute: 'Calculando rota...',
    yourLocation: 'Sua localização',
    expandAltitudeChart: 'Ampliar gráfico',
    errorRenderingContentUploaded: 'Erro ao exibir o conteúdo carregado. Verificar o formato e o conteúdo do arquivo',
    roundTrip: 'Rota circular',
    notPossibleToCalculateRoute: 'Uma rota não pôde ser calculada usando um dos locais selecionados',
    apiError: {
      2000: 'Não foi possível processar a requisição JSON',
      2001: 'Parâmetro obrigatório faltando',
      2002: 'Formato de parâmetro incorreto',
      2003: 'Os parâmetros de rota excedem um ou mais limites. Lembre-se de que alguns itens evitáveis têm limites, como o comprimento do trajeto e a área de um polígono evitado que não deve exceder 20.000 quilômetros quadrados.',
      2004: 'Os parâmetros de rota excedem um ou mais limites. Lembre-se de que a distância aproximada da rota não deve ser superior a 6000 km. Quando certas opções de rota ou itens evitáveis são usados, a distância aproximada da rota não deve ser maior que 150 kms.',
      2006: 'Não foi possível analisar o pedido e processar a resposta',
      2007: 'Formato de resposta não suportado',
      2008: 'Elemento vazio',
      2009: 'Não foi possível encontrar uma rota adequada para os locais e critérios especificados. Talvez o perfil selecionado não seja suportado nesta área/região com o(s) filtro(s) aplicado(s).',
      2010: 'Não foi possível encontrar um ponto adequado para processar a rota. Talvez um dos pontos selecionados não seja roteável ou o perfil selecionado não seja suportado nesta região.',
      2011: 'Ao utilizar a opção de rotas alternativas, não é possível definir paradas adicionais',
      2012: 'Foi especificado um parâmetro inválido. Certifique-se de que a URL esteja correta',
      2099: 'Não foi possível calcular a rota'
    },
    genericErrorMsg: 'Não foi possível calcular a rota',
    reorder: 'Reordenar',
    timeoutError: 'A solicitação demorou muito e foi abortada. Tente distâncias mais curtas.',
  }
}
